import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CopyableThrowableClass;
function CopyableThrowable() {
  if (CopyableThrowableClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'CopyableThrowable');
    CopyableThrowableClass = $;
  }
  return CopyableThrowableClass;
}
//region block: exports
export {
  CopyableThrowable as CopyableThrowable1mvc99jcyvivf,
};
//endregion

//# sourceMappingURL=Debug.common.mjs.map
